import React from 'react';
import Icon from '../../../components/AppIcon';

const CertificationsSection = () => {
  const certifications = [
    {
      category: "Industry Certifications",
      items: [
        { name: "CFOT (Certified Fiber Optic Technician)", issuer: "FOA", status: "Active" },
        { name: "BICSI Certified", issuer: "BICSI", status: "Active" },
        { name: "RCDD (Registered Communications Distribution Designer)", issuer: "BICSI", status: "Active" },
        { name: "FOI (Fiber Optic Installer)", issuer: "ETA International", status: "Active" }
      ]
    },
    {
      category: "Safety Certifications",
      items: [
        { name: "OSHA 30-Hour Construction", issuer: "OSHA", status: "Active" },
        { name: "Confined Space Entry", issuer: "NFPA", status: "Active" },
        { name: "Fall Protection Certified", issuer: "ANSI", status: "Active" },
        { name: "Electrical Safety Training", issuer: "NFPA 70E", status: "Active" }
      ]
    },
    {
      category: "Manufacturer Partnerships",
      items: [
        { name: "Corning Certified Partner", issuer: "Corning Inc.", status: "Gold Level" },
        { name: "CommScope Authorized Installer", issuer: "CommScope", status: "Premier" },
        { name: "Panduit Certified", issuer: "Panduit Corp.", status: "Active" },
        { name: "Belden Authorized Partner", issuer: "Belden Inc.", status: "Active" }
      ]
    }
  ];

  const insuranceCoverage = [
    { type: "General Liability", amount: "$2,000,000", provider: "Travelers Insurance" },
    { type: "Professional Liability", amount: "$1,000,000", provider: "Hiscox" },
    { type: "Workers Compensation", amount: "Full Coverage", provider: "State Fund" },
    { type: "Commercial Auto", amount: "$1,000,000", provider: "Progressive" }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-text-primary mb-4">
            Certifications & Credentials
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Our comprehensive certifications and insurance coverage provide the assurance you need for critical infrastructure projects.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Certifications */}
          <div className="space-y-8">
            <h3 className="text-2xl font-semibold text-text-primary">Professional Certifications</h3>
            
            {certifications?.map((category, categoryIndex) => (
              <div key={categoryIndex} className="space-y-4">
                <h4 className="text-lg font-semibold text-primary">{category?.category}</h4>
                <div className="space-y-3">
                  {category?.items?.map((cert, certIndex) => (
                    <div key={certIndex} className="flex items-center justify-between p-4 bg-surface rounded-lg">
                      <div className="flex items-center space-x-3">
                        <div className="p-2 bg-primary/10 rounded-lg">
                          <Icon name="Award" size={20} className="text-primary" />
                        </div>
                        <div>
                          <h5 className="font-medium text-text-primary">{cert?.name}</h5>
                          <p className="text-sm text-text-secondary">{cert?.issuer}</p>
                        </div>
                      </div>
                      <span className="px-3 py-1 bg-accent/10 text-accent text-sm rounded-full">
                        {cert?.status}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          
          {/* Insurance & Bonding */}
          <div className="space-y-8">
            <h3 className="text-2xl font-semibold text-text-primary">Insurance & Financial Protection</h3>
            
            <div className="space-y-4">
              <h4 className="text-lg font-semibold text-primary">Coverage Details</h4>
              <div className="space-y-3">
                {insuranceCoverage?.map((coverage, index) => (
                  <div key={index} className="flex items-center justify-between p-4 bg-surface rounded-lg">
                    <div className="flex items-center space-x-3">
                      <div className="p-2 bg-accent/10 rounded-lg">
                        <Icon name="Shield" size={20} className="text-accent" />
                      </div>
                      <div>
                        <h5 className="font-medium text-text-primary">{coverage?.type}</h5>
                        <p className="text-sm text-text-secondary">{coverage?.provider}</p>
                      </div>
                    </div>
                    <span className="font-semibold text-primary">{coverage?.amount}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="p-6 bg-primary/5 rounded-xl border border-primary/20">
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-primary/10 rounded-lg">
                  <Icon name="FileCheck" size={24} className="text-primary" />
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-text-primary mb-2">
                    Bonding & Financial Stability
                  </h4>
                  <p className="text-text-secondary mb-4">
                    We maintain comprehensive bonding coverage and financial stability documentation for enterprise procurement processes.
                  </p>
                  <div className="space-y-2">
                    <div className="flex items-center space-x-2">
                      <Icon name="CheckCircle" size={16} className="text-accent" />
                      <span className="text-sm text-text-secondary">Performance Bond: Up to $5,000,000</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="CheckCircle" size={16} className="text-accent" />
                      <span className="text-sm text-text-secondary">Payment Bond: Up to $5,000,000</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="CheckCircle" size={16} className="text-accent" />
                      <span className="text-sm text-text-secondary">Financial Statements: Audited Annually</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;